<footer class='footer'>
  <div class='main-container'>
    <h2 class='sr-only'>stopka {{ name }}</h2>
    <div class='links' id='footer-links'>
      <a routerLink='/strona-glowna' class='logo'>
        <img [src]='appLogoPath' alt='Miasto Łódź logotyp' width='30' aria-hidden='true'>
        <span class='sr-only'>Strona główna <span class='sr-only'>{{ name }}</span></span> <span
        aria-hidden="true">{{ name }}</span>
      </a>
      <ul class="subpages">
        <li><a routerLink='/jak-korzystac'>Jak korzystać</a></li>
        <li><a routerLink='/info/o-projekcie'>O projekcie</a></li>
        <li><a routerLink='/info/polityka-prywatnosci'>Polityka prywatności</a></li>
        <li><a routerLink='/info/regulamin'>Regulamin</a></li>
        <li><a routerLink='/info/deklaracja-dostepnosci'>Deklaracja dostępności</a></li>
        <li><a routerLink='/info/kontakt'>Kontakt</a></li>
      </ul>
      <br>
    </div>
    @if (showFooterEULogotypes) {
      <div class='eu-logotypes'>
        <img src='/img/logotypy_stopka.png'
             alt='Funduszy Europejskie dla Warmii i Mazur, Rzeczpospolita polska, Dofinansowane przez Unię Europejską'>
      </div>
    }
  </div>
</footer>
<div class='appVersion'>Version: {{ version }} <span *ngIf="!production" class="color--dark-red">&nbsp;(dev mode)</span></div>
